const types = {
  ABRIR_DIALOG_EDICAO: 'ABRIR_DIALOG_EDICAO',
  FECHAR_DIALOG_EDICAO: 'FECHAR_DIALOG_EDICAO',
  SET_LISTA_ITENS_GLOSSARIO: 'SET_LISTA_ITENS_GLOSSARIO',
  CRIAR_ITEM_GLOSSARIO: 'CRIAR_ITEM_GLOSSARIO',
  EDITAR_ITEM_GLOSSARIO: 'EDITAR_ITEM_GLOSSARIO',
  EXCLUIR_ITEM_GLOSSARIO: 'EXCLUIR_ITEM_GLOSSARIO',
  SHOW_GLOBAL_LOADING: 'ui/SHOW_GLOBAL_LOADING',
  HIDE_GLOBAL_LOADING: 'ui/HIDE_GLOBAL_LOADING',
  SHOW_SNACKBAR: 'ui/SHOW_SNACKBAR',
  HIDE_SNACKBAR: 'ui/HIDE_SNACKBAR',
  SHOW_CONFIRMATION_DIALOG: 'ui/SHOW_CONFIRMATION_DIALOG',
  HIDE_CONFIRMATION_DIALOG: 'ui/HIDE_CONFIRMATION_DIALOG',
  SET_LISTA_TIPOS_DOCUMENTO: 'SET_LISTA_TIPOS_DOCUMENTO'
}

export default types



// WEBPACK FOOTER //
// ./src/vuex/administracao/mutations-types.js